/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListadoEncuestasModelDto } from '../../models/listado-encuestas-model-dto';

export interface DoctorEncuestasControllerObtenerEncuestas$Params {
}

export function doctorEncuestasControllerObtenerEncuestas(http: HttpClient, rootUrl: string, params?: DoctorEncuestasControllerObtenerEncuestas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoEncuestasModelDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerEncuestas.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListadoEncuestasModelDto>>;
    })
  );
}

doctorEncuestasControllerObtenerEncuestas.PATH = '/api/doctor-encuestas/lista-encuestas';
